import { useDispatch, useSelector } from "react-redux";
import { Loader } from "@progress/kendo-react-indicators";
import RefreshIcon from "../../../assets/header/refresh.svg";
import "../shuttle_bus_booking.css";
import { useLocation, useNavigate } from "react-router";
import { TableHeader } from "../../../components/reusableItems/header";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";
import {
  checkPermission,
  getUserPermission,
} from "../../../config/permission_helper";
import { Reusable_table } from "../../../components/reusableItems/table";
import {
  ConfigDataOridnary,
  ConfigDataSpecial,
} from "./configData";
import { fetchSetMaximumList } from "../../../store/shuttle_bus_booking/set_maximum";
import { useEffect, useState } from "react";
import { deleteRouteById, deleteSpecialRouteById, fetchOrdinaryRouteList, fetchSpecialRouteList, updateRouteStatus } from "../../../store/shuttle_bus_booking/shuttle_bus_route";
import { SHUTTLE_BUS_BOOKING_ROUTE_DETAILS, SHUTTLE_BUS_BOOKING_ROUTE_ORDINARY_UPDATE, SHUTTLE_BUS_BOOKING_ROUTE_SPECIAL_UPDATE, SHUTTLE_BUS_BOOKING_SET_STATION_DETAILS, SHUTTLE_BUS_BOOKING_SET_STATION_UPDATE } from "../../../routes";
import { ShowDialog } from "../../../components/reusableItems/dialog";
import moment from "moment/moment";

export const SHUTTLE_BUS_BOOKING_ROUTE_TABS = {
  ORDINARY_ROUTE: "Ordinary Day Route",
  SPECIAL_ROUTE: "Special Day Route",
};

export const ShuttleBusBookingRouteListing = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showDelete, setShowDelete] = useState(false);
  const [showStatus, setShowStatus] = useState(false);
  const [tempStatus, setTempStatus] = useState("");
  const [actionID, setActionID] = useState("");
  const [actionType, setActionType] = useState("");
  const [tempData, setTempData] = useState([]);
  const [tempSpecialData, setTempSpecialData] = useState([]);
  const [tab, setTab] = useState(SHUTTLE_BUS_BOOKING_ROUTE_TABS.ORDINARY_ROUTE);
  let { search } = useLocation();
  const query = new URLSearchParams(search);
  const type = query.get("type");

  const { loading } = useSelector(
    (state) => state.shuttleBusRoute
  );

  const userPermissions = getUserPermission();

  const viewPermssionOrdinary = checkPermission(
    userPermissions,
    "bus_booking.access_bus_booking_route"
  );
  const viewPermssionSpecial = checkPermission(
    userPermissions,
    "bus_booking.access_special_days"
  );

  const viewPermssion = viewPermssionOrdinary || viewPermssionSpecial;

  const AddPermssionOrdinary = checkPermission(
    userPermissions,
    "bus_booking.create_bus_booking_route"
  ) || false;

  const AddPermssionSpecial = checkPermission(
    userPermissions,
    "bus_booking.create_special_days"
  ) || false;

  const AddPermssion = AddPermssionOrdinary || AddPermssionSpecial;


  const getData = async (callback) => {
    if (tab === SHUTTLE_BUS_BOOKING_ROUTE_TABS.ORDINARY_ROUTE) {
      dispatch(fetchOrdinaryRouteList()).then((res) => {
        const formattedData = res.payload.map(item => ({
          ...item,
          id: item.route_id
        }));

        setTempData([...formattedData]);
      });
    } else {
      dispatch(fetchSpecialRouteList()).then((res) => {
        const formattedData = res.payload.map(item => ({
          ...item,
          id: item.route_id,
          start_date: moment(item.start_date, "YYYY-MM-DD").format("DD MMM YYYY"),
          end_date: moment(item.end_date, "YYYY-MM-DD").format("DD MMM YYYY"),
        }));

        setTempSpecialData([...formattedData]);
      });
    }
  };

  const actionTrigger = () => {
    if (actionType === "Delete") {
      setShowDelete(false);

      if (tab == SHUTTLE_BUS_BOOKING_ROUTE_TABS.ORDINARY_ROUTE) {
        dispatch(deleteRouteById(actionID)).then((res) => {
          getData();

        });
      } else {
        dispatch(deleteSpecialRouteById(actionID)).then((res) => {
          getData();

        });
      }
    }
  };


  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    getData();
  }, [tab]);

  useEffect(() => {
    if (type == 'special') {
      setTab(SHUTTLE_BUS_BOOKING_ROUTE_TABS.SPECIAL_ROUTE)
    } else {
      setTab(SHUTTLE_BUS_BOOKING_ROUTE_TABS.ORDINARY_ROUTE)
    }
  }, [type]);


  const updateStatus = () => {
    setShowStatus(false);

    let params = { status: tempStatus, id: actionID }

    dispatch(updateRouteStatus({ data: params, id: actionID })).then((res) => {
      getData();
    });
  };



  const handleTableClick = (type, id) => {

    if (type === "View Details") {
      navigate(`${SHUTTLE_BUS_BOOKING_ROUTE_DETAILS}?id=${id}&type=${tab === SHUTTLE_BUS_BOOKING_ROUTE_TABS.ORDINARY_ROUTE ? 'ordinary' : 'special'}`);
    } else if (type === "Update Status") {
      setActionID(id);
      setActionType(type);
      setShowStatus(true);
      const result = tempData.find(item => item.route_id === id);
      setTempStatus(result.status);
    }
    else if (type === "Delete") {

      setActionID(id);
      setActionType(type);
      if (type === "Delete") {
        setShowDelete(true);
      }
    }

  };

  const RefreshData = () => {
    getData();
  };




  const handleCreateAction = () => {
    if (tab === SHUTTLE_BUS_BOOKING_ROUTE_TABS.ORDINARY_ROUTE) {
      navigate(`${SHUTTLE_BUS_BOOKING_ROUTE_ORDINARY_UPDATE}`);
    } else {
      navigate(`${SHUTTLE_BUS_BOOKING_ROUTE_SPECIAL_UPDATE}`);
    }
  };

  const icons = [
    ...(AddPermssion ? [{
      buttonName: "+ Add new",
      action: handleCreateAction,
    }] : []),
    {
      icon: RefreshIcon,
      title: "Refresh",
      action: RefreshData,
    },
    // {
    //   icon: ExportIcon,
    //   title: "Export",
    //   action: handleExport,
    // },
  ];

  const onTabChange = (tab) => {
    setTab(tab);
  };

  return (
    <>
      {viewPermssion ? (
        <div className="container">



          <TableHeader title={"Shutting Bus Route"} icons={icons} />

          {showDelete && (
            <ShowDialog
              title={"Please Confirm!"}
              content={"Are you sure you want to delete?"}
              cancelContent={"Cancel"}
              confrimContent={"Delete"}
              cancelbtn={() => setShowDelete(false)}
              confrinbtn={actionTrigger}
            />
          )}

          {showStatus && (
            <ShowDialog
              cancelbtn={() => setShowStatus(false)}
              title={"Update Status"}
              dropdownContent={"Set status"}
              dropdown={true}
              cancelContent={"Cancel"}
              confrimContent={"Update"}
              confrinbtn={updateStatus}
              dropdownData={["Active", "Inactive", "Suspension"]}
              dropdownOnChange={(e) => setTempStatus(e)}
              dropdownValue={tempStatus}
            />
          )}


          {(<div className="shuttle_bus_booking_child_box_main_detail_box">

            <div className="tabs" style={{ marginLeft: '30px' }}>
              {viewPermssionOrdinary &&
                <><div
                  onClick={() => {
                    onTabChange(SHUTTLE_BUS_BOOKING_ROUTE_TABS.ORDINARY_ROUTE);
                  }}
                  className={`tab ${tab === SHUTTLE_BUS_BOOKING_ROUTE_TABS.ORDINARY_ROUTE ? "isactive" : ""
                    }`}
                >
                  {SHUTTLE_BUS_BOOKING_ROUTE_TABS.ORDINARY_ROUTE}
                </div>
                  <div style={{ borderLeft: "2px solid #CCCCCC" }}></div>
                </>
              }

              {viewPermssionSpecial && <div
                onClick={() => {
                  onTabChange(SHUTTLE_BUS_BOOKING_ROUTE_TABS.SPECIAL_ROUTE);
                }}
                className={`tab ${tab === SHUTTLE_BUS_BOOKING_ROUTE_TABS.SPECIAL_ROUTE ? "isactive" : ""
                  }`}
              >
                {SHUTTLE_BUS_BOOKING_ROUTE_TABS.SPECIAL_ROUTE}
              </div>
              }

            </div>


            {loading ? (
              <Loader
                type="converging-spinner"
                style={{
                  width: "100%",
                  height: "calc(100vh - 165px)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#ffffff4d",
                  position: "absolute",
                  zIndex: "999",
                }}
              />
            ) : (
              (tab === SHUTTLE_BUS_BOOKING_ROUTE_TABS.ORDINARY_ROUTE && viewPermssionOrdinary) ? (
                <Reusable_table
                  key={tempData && tempData.map(i => i.status).join("-")}
                  header={ConfigDataOridnary}
                  data={tempData}
                  pagination={true}
                  calculatePagi={true}
                  pageChangeLoading={false}
                  showRow={true}
                  checkbox={false}
                  //   handleTableClick={handleTableClick}
                  handleAction={handleTableClick}
                  maxHeight={"calc(100vh - 260px)"}
                  maxWidth={"calc(100vw - 240px)"}
                />
              ) :
                (tab === SHUTTLE_BUS_BOOKING_ROUTE_TABS.SPECIAL_ROUTE && viewPermssionSpecial) ? (
                  <Reusable_table
                    key={tempSpecialData && tempSpecialData.map(i => i.status).join("-")}
                    header={ConfigDataSpecial}
                    data={tempSpecialData}
                    pagination={true}
                    calculatePagi={true}
                    pageChangeLoading={false}
                    showRow={true}
                    checkbox={false}
                    //   handleTableClick={handleTableClick}
                    handleAction={handleTableClick}
                    maxHeight={"calc(100vh - 260px)"}
                    maxWidth={"calc(100vw - 240px)"}
                  />
                )
                  : (
                    <PermissionDeninedPage
                      height={"calc(100% - 76px)"}
                      title={"Sorry, You don't have permission to access this page!"}
                    />
                  )
            )}
          </div>
          )}

        </div>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}
    </>
  );
};
